type View = Window & typeof globalThis;
const PRIVATE_NODES='input,textarea,select,form,iframe,[contenteditable],[data-bb-private]';

/** Replay is restricted to the public RU landing page, with bounded public URL labels. */
export function replayPageAllowed(href:string):boolean {
  try {
    const url=new URL(href);
    if(url.protocol!=='https:'||!['blenderbridge.ru','www.blenderbridge.ru'].includes(url.hostname)||url.pathname!=='/')return false;
    if(url.hash&&!['#film','#workflow','#capabilities','#pricing','#download','#faq'].includes(url.hash))return false;
    for(const [key,value] of url.searchParams){
      if(key==='lang'){if(!/^[a-z]{2}(?:-[A-Za-z]{2,4})?$/.test(value))return false;}
      else if(['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].includes(key)){if(!/^[\p{L}\p{N} ._-]{1,64}$/u.test(value))return false;}
      else return false;
    }
    return true;
  } catch{return false;}
}

/** Never reads values. Protection is applied before vendor code is inserted. */
export function protectReplayFields(view:View):()=>void {
  const observed=new WeakSet<Element>();
  const observer=new view.MutationObserver(records=>{
    for(const record of records){
      if(record.type==='attributes')scan(record.target);
      for(const node of record.addedNodes)scan(node);
    }
  });
  function protect(element:Element):void {
    if(element.classList.contains('ym-record-keys'))element.classList.remove('ym-record-keys');
    for(const name of ['ym-hide-content','ym-disable-keys'])if(!element.classList.contains(name))element.classList.add(name);
    if(element.tagName==='FORM'&&!element.classList.contains('ym-disable-submit'))element.classList.add('ym-disable-submit');
    if(!observed.has(element)){
      observed.add(element);
      observer.observe(element,{attributes:true,attributeFilter:['class','contenteditable','data-bb-private']});
    }
  }
  function scan(node:Node):void {
    if(node.nodeType!==1&&node.nodeType!==9)return;
    const root=node as Element;
    if(root.nodeType===1&&root.matches(PRIVATE_NODES))protect(root);
    for(const element of root.querySelectorAll(PRIVATE_NODES))protect(element);
  }
  try {
    scan(view.document);
    observer.observe(view.document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['contenteditable','data-bb-private']});
  }catch(error){observer.disconnect();throw error;}
  return ()=>observer.disconnect();
}
